export default __webpack_public_path__ + "static/media/aubrey_leaser.b484eac0.jpeg";